/* eslint-disable @stylexjs/valid-styles */
import { TransitionLinkV2 } from "@/src/common/TransitionLinkV2";
import type { IImageLoader } from "@Components/ImageLoader";
import * as stylex from "@stylexjs/stylex";

import { ComposableSpacing, colors } from "../../styles/tokens.stylex";

export type IArticleBox = {
    title: string;
    description: string;
    uri: string;
    image: IImageLoader;
    buttonText?: string;
};

const styles = stylex.create({
    articleBoxComponent: {
        paddingBlock: "0",
        paddingInline: "10px",
        textAlign: "center",
    },

    button: {
        borderColor: colors.b_centas,
        borderRadius: ComposableSpacing.s1,
        borderStyle: "solid",
        borderWidth: "1px",
        marginBlock: "15px",
        marginInline: "0",
        paddingBlock: "10px",
        paddingInline: "20px",
        transition: "background-color 0.3s ease",
        backgroundColor: { default: null, [":hover"]: colors.b_centas },
        display: "inline-block",
    },

    imageLink: {
        padding: 0,
    },

    captionTitle: {
        overflow: "hidden",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": 2,
        display: "-webkit-box",
        fontSize: "1.1875rem",
        textOverflow: "ellipsis",
    },

    text: {
        overflow: "hidden",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": 3,
        display: "-webkit-box",
        fontSize: "0.8125rem",
        fontWeight: 300,
        textOverflow: "ellipsis",
        height: "4.5em",
    },
    hr: {
        borderColor: colors.b_centas,
        borderStyle: "solid",
        borderWidth: "1px",
        marginBlock: "15px",
        marginInline: "0",
    },
});

export default function ArticleBox(props: IArticleBox) {
    return (
        <div {...stylex.props(styles.articleBoxComponent)}>
            <TransitionLinkV2 href={props.uri} styleX={styles.imageLink} variant="transparentMagenta">
                <img src={props.image.src} alt={props.image.alt} />
            </TransitionLinkV2>
            <h5 {...stylex.props(styles.captionTitle)} dangerouslySetInnerHTML={{ __html: props.title }} />
            <p {...stylex.props(styles.text)}>{props.description}</p>
            <hr {...stylex.props(styles.hr)} />
            <TransitionLinkV2 href={props.uri} styleX={styles.button} variant="transparentMagenta">
                {props.buttonText || "Czytaj więcej"}
            </TransitionLinkV2>
        </div>
    );
}
